export default "__VITE_ASSET__DSjd_mDF__"